export const ApiKeysActionTypes = {
    API_RESPONSE_SUCCESS: '@@apiKeys/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@apiKeys/API_RESPONSE_ERROR',
    GET_ALL_API_KEYS: '@@apiKeys/GET_ALL_API_KEYS',
    CREATE_API_KEY: '@@apiKeys/CREATE_API_KEY',
    DELETE_API_KEY: '@@apiKeys/DELETE_API_KEY',
    RESET_ALL_ERRORS: '@@apiKeys/RESET_ALL_ERRORS',
};
